module.exports = __webpack_public_path__ + "img/算法绑定一键导入.4dc8e43c.svg";